export default __webpack_public_path__ + "static/media/ogp_tb.26fb3b3f.png";